var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h2',{staticClass:"heading-sm"},[_vm._v(" "+_vm._s(_vm.$ls.Documents_Table_Heading_UsedInApplications)+" "),_c('popover-info',[_vm._v(" "+_vm._s(_vm.$ls.Documents_Info_DocumentEditingTableInfo)+" ")])],1),_c('SeafarerDashboardApplicationTable',{attrs:{"applications":_vm.usedInApplications}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }